<!-- static content data from lang: patient_list -->
<template>
  <div class="container">
    <div class="my-3" v-loading="loading" >
      <b-card class="patient-listing">
        <div class="row">
          <template v-if="errored"> {{lang.label.error}}</template>
          <template v-else>
            <template v-if="data.length > 0">
              <div class="col-md-6 col-lg-4" v-for="(patient, index) in data" :key="index">
                <b-card class="shadow-none appointment-card" body-class="p-3" @click="cardClicked(patient)">
                  <div class="row">
                    <div class="col-6 col-lg-5">
                      <span class="mb-2 d-block">{{lang.label.name}}:</span>
                    </div>
                    <div class="col-6 col-lg-7">
                      <span class="mb-2 d-block">{{(patient.name!=''? patient.name :lang.label.nodata)}}</span>
                    </div>
                    <div class="col-6 col-lg-5" >
                      <span class="mb-2 d-block">{{lang.label.emailId}}:</span>
                    </div>
                    <div class="col-6 col-lg-7">
                      <span class="mb-2 d-block">{{(patient.email!=''? patient.email :lang.label.nodata)}}</span>
                    </div>
                    <div class="col-6 col-lg-5">
                      <span class="mb-2 d-block">{{lang.label.phoneNumber}}:</span>
                    </div>
                    <div class="col-6 col-lg-7">
                      <span class="mb-2 d-block">{{(patient.mobile!=''? patient.mobile :lang.label.nodata)}}</span>
                    </div>
                    <div class="col-6 col-lg-5">
                      <span class="mb-2 d-block">{{lang.label.receivedDate}}:</span>
                    </div>
                    <div class="col-6 col-lg-7">
                      <span class="mb-2 d-block">{{formatDate(patient.createdAt)}}</span>
                    </div>
                  </div>
                </b-card>
              </div>
            </template>
            <template v-else>
              <div class="col-12 text-center pt-3">{{lang.label.noDataFound}}</div>
            </template>
          </template>
        </div>
      </b-card>
    </div>
    <b-modal id="modal-center" centered hide-footer>
      <div class="share-buttons">
        <b-btn variant="primary" class="w-100"><a style="color:#FFF" target="_blank" @click="createScript(1)">{{lang.label.buttons.createScript}}</a></b-btn>
        <b-btn variant="primary" class="w-100 btn-copy" @click="createScript(2)">{{lang.label.buttons.createEScript}}</b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
  var moment = require('moment');
  export default {
    components: {},
    data() {
      return {
        patientInfo: '',
        data: [],
        lang: this.$lang.script_requests,
        loading: true,
        errored: false
      };
    },
    mounted() {
      this.$store.dispatch('appointmentList', {status:0})
              .then(response => {
                this.data = response.data;
                // this.data = [{"patientId":602,"name":"Chirag Patient","email":"patient@mailinator.com","mobile":"0989898989","gender":"","bloodGroup":"","dob":"","address":"","pharmacistId":593,"pharmacistName":"pharmacy name","pharmacistEmail":"pharmact@mailinator.com","pharmacistMobile":"0999999999","appointmentId":22,"idNumber":"7545SA","isMinor":1,"parentName":"Guard A","idNumberParent":"ADE564","medicine":"benadon 10","specialInstructions":"No special"},{"patientId":601,"name":"north Guwahati","email":"admin@pragati.com","mobile":"0987987987","gender":"","bloodGroup":"","dob":"","address":"","pharmacistId":593,"pharmacistName":"pharmacy name","pharmacistEmail":"0999999999","pharmacistMobile":"pharmact@mailinator.com","appointmentId":23,"idNumber":"7545WESA","isMinor":1,"parentName":"Guard AA","idNumberParent":"ADES3564","medicine":"benadon 100","specialInstructions":"No special"}]
              })
              .catch(error => {
                this.errored = true;
              })
              .finally(() => this.loading = false)
    },
    methods: {
      formatDate(date) {
        return date ? moment(date).format('DD/MM/YYYY HH:mm:ss') : this.lang.label.nodata;
      },
      cardClicked(data){
          this.$store.commit('setScriptRequestDetails',data);
		 this.$router.push({ name: 'script-details' });
//        this.patientInfo = patient;
//        this.$bvModal.show('modal-center');
      },
      createScript(type){
        this.$store.commit('setPatientInfo',this.patientInfo);
        this.$store.commit('setFromGroupRequests', false);
        if(type == 1){
          this.$router.push({name: 'create-script'});
        }else{
          this.$router.push({name: 'create-electronic-script'});
        }
      }
    }
  };
</script>
